import React from 'react'
import PropTypes from 'prop-types'
import Button from '~components/button'
import Spinner from '~components/spinner'
import './style.scss'

function LoadingButton({
  variant,
  type,
  size,
  onClick,
  disabled,
  isLoading,
  className,
  children,
  isMobile,
  ariaLabel,
  spinnerSize,
  spinnerBorderWidth,
}) {
  return (
    <Button
      type={type}
      size={size}
      // variant="primary"
      variant={variant || 'primary'}
      disabled={disabled}
      onClick={onClick}
      className={`loading-btn${className ? ` ${className}` : ''}`}
      ariaLabel={ariaLabel}
    >
      {isLoading ? (
        <Spinner
          size={isMobile ? spinnerSize || 22 : spinnerSize || 30}
          color="#fff"
          borderWidth={spinnerBorderWidth || 3}
        />
      ) : (
        children
      )}
    </Button>
  )
}

LoadingButton.propTypes = {
  type: PropTypes.string,
  size: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  isMobile: PropTypes.bool,
  ariaLabel: PropTypes.string.isRequired,
  spinnerSize: PropTypes.number,
  spinnerBorderWidth: PropTypes.number,
}

export default LoadingButton
export { LoadingButton }



// WEBPACK FOOTER //
// ./src/components/loading-button/index.js